export default __webpack_public_path__ + "static/media/sn2.05d1a88b.jpg";